import { Tone } from '../theme';

/* The one map from a bill's simpleStage to its badge tone and sort order.
   Replaces the per-page stage color maps. Unknown stages fall back to אחר. */

export const STAGES: Record<string, { tone: Tone; order: number }> = {
  'עברה':                { tone: 'success', order: 0 },
  'קריאה שלישית':        { tone: 'warning', order: 1 },
  'קריאה שנייה ושלישית': { tone: 'warning', order: 2 },
  'קריאה ראשונה':        { tone: 'warning', order: 3 },
  'בוועדה':              { tone: 'info',    order: 4 },
  'דיון מוקדם':           { tone: 'info',    order: 5 },
  'נעצרה':               { tone: 'danger',  order: 6 },
  'מוזגה':               { tone: 'neutral', order: 7 },
  'הוסבה':               { tone: 'neutral', order: 8 },
  'אחר':                 { tone: 'neutral', order: 9 },
};

export const stageInfo = (stage: string | undefined) => STAGES[stage || 'אחר'] || STAGES['אחר'];
